<script lang="ts" setup>
const { $config } = useNuxtApp()
const route = useRoute()
const locationList = ref()

if (isEmpty(useGetSubdomain()))
  navigateTo('', { redirectCode: 301 })

getLocation()
updateMeta()

async function getLocation() {
  const { data, error } = await useCompanyApi(`job/location/directory/${useGetSubdomain()}`, {
    method: 'GET',
    initialCache: false,
    useAuth: true,
  })

  const resp = data?.value as { success: boolean; data: [] }
  if (!isEmpty(resp) && resp?.success)
    locationList.value = resp.data
}

function updateMeta() {
  const metaTitle = 'Find Job Location - Epicareer'
  const metaDesc = 'Find jobs near you with Epicareer! Explore job locations, salaries, and top hiring companies. Start your job search today and land your next career move'
  const robotsDefault = ($config.public.ENV === 'development' || $config.public.ENV === 'staging') ? { name: 'robots', content: 'nofollow, noindex' } : { name: 'robots', content: 'index, follow' }

  useHead({
    title: metaTitle,
    meta: [
      { property: 'og:title', content: metaTitle },
      { name: 'twitter:title', content: metaTitle },
      { name: 'description', content: metaDesc },
      { property: 'og:description', content: metaDesc },
      { name: 'twitter:description', content: metaDesc },
      robotsDefault,
    ],
    link: [
      { rel: 'canonical', href: useSetSubdomain(useGetSubdomain()) + route.path },
    ],
  })
}
</script>

<template>
  <BaseAtomsSkeletonBounded class="!py-0 !xl:px-0 text-gray-900">
    <!-- JOBS BY LOCATIONS -->
    <p class="text-4xl font-bold font-serif pt-6 md:pt-10">
      Jobs by Locations
    </p>
    <div class="bg-[#F9FAFB] p-4 space-y-6 lg:columns-3">
      <div v-for="(item, idx) in locationList" :key="idx" class="break-inside-avoid">
        <p class="text-sm font-semibold mb-1">
          {{ idx }}
        </p>
        <div class="flex flex-wrap">
          <NuxtLink v-for="(item2, idx2) in item" :key="idx2" :to="useGenerateSearchUrl('', item2)" class="text-xs text-[#5843E5] flex items-center mb-1 cursor-pointer">
            {{ item2 }}
            <div class="border-r-1 border-gray-500 mx-2 h-3" />
          </NuxtLink>
        </div>
      </div>
    </div>
  </BaseAtomsSkeletonBounded>
</template>
